import { useState, createContext, useEffect } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { userParticularGet } from "../Store/Actions/UserActions";
import {
  RESUME_PREVIEW_RESET,
  RESUME_DUPLICATE_RESET,
  RESUME_CREATE_RESET,
} from "../Store/Constants/ResumeConstants";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
  Redirect,
} from "react-router-dom";
import { COVER_CREATE_RESET } from "../Store/Constants/CoverLetterConstants";
export const userTypeContext = createContext(null);

export const UserTypeContextProvider = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const path = window.location.pathname;
  const [userType, setUserType] = useState("free");
  const [isIndianUser, setIsIndianUser] = useState(false);
  const [userCountryCode, setUserCountryCode] = useState("US");
  const [showProPopup, setShowProPopup] = useState(false);
  const [popupType, setPopupType] = useState("resume");
  const [showProPopupMessage, setShowProPopupMessage] = useState(false);
  const [resumeCount, setResumeCount] = useState("");
  const [coverCount, setCoverCount] = useState("");
  const [maxCount, setMaxCount] = useState(1);
  const [isOverdue, setIsOverdue] = useState(false);
  const [hostedInvoiceUrl, setHostedInvoiceUrl] = useState(null);
  const particularData = useSelector((state) => state.particularuser);
  const userInfo = useSelector((state) => state.userData.userInfo);
  const resumeCreate = useSelector((state) => state.createResume);
  const coverCreate = useSelector((state) => state.coverCreate);
  const resumeDuplicate = useSelector((state) => state.duplicateResume);
  const resumePreview = useSelector((state) => state.resumePreview);
  const [subscriptions, setSubscriptions] = useState([]);
  const [subscriptionItems, setSubscriptionItems] = useState([]);
  const baseUrl = process.env.REACT_APP_API_URL;
  const userToken = useSelector((state) => state.userData);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (particularData && particularData.user) {
      setUserType(particularData?.user?.type);
      setResumeCount(particularData?.user?.resume_count);
      setCoverCount(particularData?.user?.cover_count);
      setMaxCount(particularData?.user?.max_count);
    } else if (userInfo && userInfo.user) {
      setUserType(userInfo?.user?.type);
    }
  }, [particularData, userInfo]);

  useEffect(() => {
    const fetchUserSubscriptions = async () => {
      console.log(userToken, "coming");
      try {
        const token = localStorage.getItem("authToken");
        const response = await fetch(`${baseUrl}/api/user/subscriptions`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${userToken.userInfo.token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ userData: userToken.userInfo.user.id }),
        });

        if (!response.ok) {
          if (response.status === 401) {
            setError("Unauthorized. Please log in.");
          } else {
            const errorData = await response.json();
            setError(
              `Failed to fetch subscriptions: ${
                errorData.message || response.statusText
              }`
            );
          }
          return;
        }

        const data = await response.json();
        console.log(data, "overdueSubscription");

        setSubscriptions(data.subscriptions);
        setSubscriptionItems(data.subscription_items);

        // Check for overdue subscriptions and set the state
        const overdueSubscription = data.subscriptions.find(
          (sub) =>
            sub.payment_status === "overdue" ||
            sub.payment_status === "past_due"
        );

        if (overdueSubscription) {
          setIsOverdue(true);
          const relatedSubscriptionItem = data.subscription_items.find(
            (item) =>
              item.subscription_id === overdueSubscription.subscription_id
          );
          if (relatedSubscriptionItem?.hosted_invoice_url) {
            setHostedInvoiceUrl(relatedSubscriptionItem.hosted_invoice_url);
          } else {
            setHostedInvoiceUrl(null); // Ensure it's null if no invoice URL
          }
        } else {
          setIsOverdue(false);
          setHostedInvoiceUrl(null);
        }
      } catch (err) {
        setError(`An unexpected error occurred: ${err.message}`);
      }
    };

    fetchUserSubscriptions();
  }, [baseUrl, userToken]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get("https://geolocation-db.com/json/");
        if (data?.country_code) {
          setUserCountryCode(data.country_code);
          setIsIndianUser(data.country_code === "IN");
        }
      } catch (error) {
        console.log("error", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (resumeCreate?.create?.message) {
      if (path?.includes("resume")) {
        history.push("/home");
        setShowProPopup(true);
        setShowProPopupMessage(resumeCreate.create.message);
        setPopupType("resume");
      } else {
        setShowProPopup(true);
        setShowProPopupMessage(resumeCreate.create.message);
        dispatch({ type: RESUME_CREATE_RESET });
        setPopupType("resume");
      }
    }
  }, [resumeCreate, history, path, dispatch]);

  useEffect(() => {
    if (coverCreate?.data?.message) {
      if (path?.includes("cover")) {
        history.push("/home");
        setShowProPopup(true);
        setShowProPopupMessage(coverCreate.data.message);
        dispatch({ type: COVER_CREATE_RESET });
        setPopupType("resume");
      } else {
        setShowProPopup(true);
        setShowProPopupMessage(coverCreate.data.message);
        dispatch({ type: COVER_CREATE_RESET });
        setPopupType("resume");
      }
    }
  }, [coverCreate, history, path, dispatch]);

  useEffect(() => {
    if (resumeDuplicate?.data?.message) {
      setShowProPopup(true);
      dispatch({ type: RESUME_DUPLICATE_RESET });
    }
  }, [resumeDuplicate, dispatch]);

  useEffect(() => {
    if (resumePreview?.data?.message) {
      setShowProPopup(true);
      setShowProPopupMessage(resumePreview.data.message);
      dispatch({ type: RESUME_PREVIEW_RESET });
      setPopupType("download");
    }
  }, [resumePreview, dispatch]);

  return (
    <userTypeContext.Provider
      value={{
        userType,
        setUserType,
        resumeCount,
        setResumeCount,
        coverCount,
        maxCount,
        popupType,
        setPopupType,
        showProPopup,
        setShowProPopup,
        showProPopupMessage,
        setShowProPopupMessage,
        isIndianUser,
        userCountryCode,
        isOverdue,
        hostedInvoiceUrl,
      }}
    >
      {props.children}
    </userTypeContext.Provider>
  );
};
